import { render, staticRenderFns } from "./ExpertHome.vue?vue&type=template&id=b81d33d6&"
import script from "./ExpertHome.vue?vue&type=script&lang=js&"
export * from "./ExpertHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports